import { ConfiguratorConfig, ConfigurationsRegistry } from '@icc/configurator/types';
import { CoupledWindowActiveConfiguration } from './coupled-window-active-configuration';
import { CoupledWindowConfiguration } from './coupled-window-configuration';

export const COUPLED_WINDOW_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'coupled_window',
    activeConfigurationClass: CoupledWindowActiveConfiguration,
    configurationClass: CoupledWindowConfiguration
};

export function registerCoupledWindowConfigurations(): void {
    ConfigurationsRegistry.register(COUPLED_WINDOW_CONFIGURATOR_CONFIG);
}
